import { render } from "./OffDayApprovals.vue?vue&type=template&id=5aca1a04"
import script from "./OffDayApprovals.vue?vue&type=script&lang=js"
export * from "./OffDayApprovals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__